/**
 * Dizionario el (greco).
 *
 * La Grecia è nel registro dei paesi dalla Fase 0 e `LOCALE_BY_COUNTRY`
 * suggeriva `el` a un host di Atene: senza questo file `/api/geo` rispondeva
 * `supported: false` e l'interfaccia restava in inglese.
 *
 * Le chiavi devono essere identiche a quelle di `it`: il test
 * `backend/tests/test_jurisdictions.py::test_le_lingue_dichiarate_sono_quelle_tradotte`
 * confronta i file di questa cartella con `APP_LOCALES`, e
 * `test_b2b_frontend_wiring.py` controlla che ogni chiave usata da un pannello
 * esista in **ogni** lingua.
 */
export default {
  "nav": {
    "showcase": "Βιτρίνα",
    "directory": "Καταλύματα",
    "network": "Δίκτυο",
    "pricing": "Τιμές",
    "login": "Σύνδεση",
    "signup": "Καταχώριση καταλύματος",
    "dashboard": "Πίνακας",
    "logout": "Αποσύνδεση",
    "book": "Κράτηση",
    "host_area": "Διαχειρίζομαι κατάλυμα",
    "find_stay": "Βρείτε διαμονή",
    "bedbank": "Bedbank",
    "claim": "Διεκδίκηση",
    "affiliates": "Συνεργάτες",
    "merchant_area": "Περιοχή επιχείρησης",
    "merchants": "Επιχειρήσεις",
    "merchant_login": "Σύνδεση επιχείρησης",
    "merchant_login_title": "Έχω τοπική επιχείρηση",
    "merchant_space": "Χώρος επιχειρήσεων",
    "host_dashboard": "Πίνακας οικοδεσπότη",
    "account": "Λογαριασμός",
    "language": "Γλώσσα"
  },
  "landing": {
    "eyebrow": "Πλατφόρμα για καταλύματα",
    "title1": "Ιταλική φιλοξενία,",
    "title2": "σε όλο τον κόσμο.",
    "subtitle": "Προβάλετε το κατάλυμά σας, συγχρονίστε τις OTA, ανταλλάξτε δωμάτια με έμπιστους συνεργάτες. Ένα ψηφιακό σπίτι για B&B, αγροτουριστικά και ξενοδοχεία.",
    "cta_primary": "Ξεκινήστε δωρεάν",
    "cta_secondary": "Δείτε τις βιτρίνες",
    "f1_title": "Βιτρίνα σε επτά γλώσσες",
    "f1_body": "Μια δημόσια σελίδα σε ιταλικά, αγγλικά, ισπανικά, γαλλικά, γερμανικά, πορτογαλικά και ελληνικά που παρουσιάζει το κατάλυμά σας. Φωτογραφίες, δωμάτια, άμεση κράτηση με Stripe.",
    "f2_title": "Δίκτυο καταλυμάτων",
    "f2_body": "Υπερκράτηση; Στείλτε τον πελάτη σε συνεργάτη. Εθνική αγορά + τοπικές κλειστές ομάδες.",
    "f3_title": "Αιτήματα ομάδων",
    "f3_body": "Δημοσιεύστε αίτημα για μεγάλη ομάδα και τα κοντινά καταλύματα απαντούν. Κεντρικό πρωινό περιλαμβάνεται.",
    "f4_title": "Ενιαίο ημερολόγιο",
    "f4_body": "Άμεσες κρατήσεις, δωμάτια δικτύου, OTA συγχρονισμένες μέσω iCal (έρχεται). Μηδέν υπερκράτηση.",
    "f5_title": "PMS περιλαμβάνεται",
    "f5_body": "Ένα πραγματικό Property Management System μέσα στην πλατφόρμα: front office, ρεσεψιόν, καθαριότητα, κουζίνα, αγορές και ημερολόγιο εργασιών. Χωρίς επιπλέον λογισμικό.",
    "showcase_title": "Καταλύματα στη βιτρίνα",
    "showcase_sub": "Μερικά από τα σπίτια που παρουσιάζονται στο Hostaly.",
    "how_title": "Πώς λειτουργεί",
    "how_1": "Καταχωρίστε το κατάλυμά σας",
    "how_1b": "Εγγραφή σε 60 δευτερόλεπτα. Αυτόματη επαλήθευση για το MVP.",
    "how_2": "Ρυθμίστε τη βιτρίνα σε επτά γλώσσες",
    "how_2b": "Κείμενα για κάθε γλώσσα, φωτογραφίες, υπηρεσίες, δωμάτια. Δημοσιεύστε όταν είστε έτοιμοι.",
    "how_3": "Μπείτε στο δίκτυο",
    "how_3b": "Προσφέρετε δωμάτια τελευταίας στιγμής, απαντήστε σε αιτήματα ομάδων, λαμβάνετε πληρωμές.",
    "final_title": "Το ψηφιακό σπίτι των καταλυμάτων",
    "final_body": "Μία πλατφόρμα για βιτρίνα, δίκτυο και κρατήσεις."
  },
  "auth": {
    "login": "Σύνδεση",
    "register": "Καταχώριση καταλύματος",
    "email": "Email",
    "password": "Κωδικός",
    "structure": "Όνομα καταλύματος",
    "country": "Χώρα καταλύματος",
    "country_help": "Καθορίζει ποιες υποχρεώσεις σας αφορούν. Δεν είναι η γλώσσα της διεπαφής: αυτή επιλέγεται ξεχωριστά.",
    "cin_label": "Κωδικός CIN",
    "cin_help": "Εθνικός κωδικός ταυτοποίησης MITUR — υποχρεωτικός από τον νόμο (DL 145/2023). Εθνική μορφή: IT + 15 χαρακτήρες (17 συνολικά). Ορισμένες περιφέρειες όπως η Σικελία μπορούν να χρησιμοποιούν μεγαλύτερες μορφές (έως 22 χαρακτήρες). Ζητήστε τον στο bdsr.ministeroturismo.gov.it",
    "cin_not_required": "Εκτός Ιταλίας ο CIN δεν χρειάζεται: θα σας ζητήσουμε τον τοπικό αριθμό μητρώου όταν έρθει η ώρα.",
    "submit_login": "Είσοδος",
    "submit_register": "Δημιουργία λογαριασμού",
    "aff_rules": "Κανόνες συνεργασίας",
    "aff_consent": "Δηλώνω ότι διάβασα και αποδέχομαι τους",
    "aff_consent_hint": "Υποχρεωτικό για την καταχώριση: περιλαμβάνει προμήθειες, πληρωμές, υποχρεώσεις του καταλύματος και όλες τις προσφορές της σύμβασης (ρήτρα 6.4).",
    "switch_to_register": "Δεν έχετε λογαριασμό; Καταχωρίστε το κατάλυμα",
    "switch_to_login": "Έχετε ήδη λογαριασμό; Συνδεθείτε",
    "forgot": "Ξεχάσατε τον κωδικό;",
    "demo_hint": "Demo: demo@hospitalityhub.it / demo1234",
    "staff_title": "Δημιουργήστε τον λογαριασμό σας",
    "staff_hint": "Ο ιδιοκτήτης του καταλύματος σάς ανέθεσε ρόλο. Χρησιμοποιήστε ακριβώς τη διεύθυνση email με την οποία σας τον ανέθεσε: αυτή συνδέει τον λογαριασμό σας με τον ρόλο.",
    "staff_name": "Ονοματεπώνυμο",
    "staff_name_help": "Προαιρετικό. Βοηθά μόνο τους συναδέλφους να σας αναγνωρίσουν.",
    "role_label": "Ο ρόλος σας στο κατάλυμα",
    "role_general_manager": "General Manager (ιδιοκτήτης)",
    "role_operations_manager": "Operations Manager",
    "role_manager": "Manager",
    "role_operator": "Υπάλληλος (καθαριότητα/κουζίνα/επισκευές)",
    "role_help": "Καθορίζει τι μπορείτε να κάνετε στη Διαχείριση Ξενοδοχείου. Ο General Manager διαχειρίζεται τους ρόλους του προσωπικού.",
    "staff_password_hint": "Τουλάχιστον 8 χαρακτήρες.",
    "staff_submit": "Δημιουργία λογαριασμού",
    "account_created": "Ο λογαριασμός δημιουργήθηκε",
    "welcome_back": "Καλώς ήρθατε",
    "cin_invalid": "Μη έγκυρος κωδικός CIN. Πρέπει να αρχίζει με 'IT' και να ακολουθούν 14-20 αλφαριθμητικοί χαρακτήρες.",
    "cin_title": "Ξεκινά με IT + 14-20 χαρακτήρες (16-22 συνολικά, π.χ. Σικελία 18)",
    "aff_required": "Πρέπει να διαβάσετε τους Κανόνες συνεργασίας για να συνεχίσετε.",
    "google": "Συνέχεια με Google",
    "apple": "Συνέχεια με Apple",
    "soon": "σύντομα",
    "google_unavailable": "Η σύνδεση με Google δεν είναι διαθέσιμη",
    "google_not_configured": "Η σύνδεση με Google δεν έχει ρυθμιστεί σε αυτή την εγκατάσταση. Χρησιμοποιήστε email και κωδικό· το κλειδί (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET) πρέπει να προστεθεί στον διακομιστή.",
    "apple_failed": "Η σύνδεση με Apple απέτυχε",
    "contract_docx": "Λήψη πλήρους σύμβασης (DOCX)",
    "costs_title": "Πόσο σας κοστίζει το Hostaly",
    "costs_body": "Χωρίς κόστος εγγραφής. Η προμήθεια ισχύει για κάθε κράτηση και μειώνεται με το πρόγραμμα.",
    "to_staff": "Σας ανέθεσαν ρόλο σε κατάλυμα; Δημιουργήστε τον λογαριασμό εδώ",
    "host_plans": "Προγράμματα για οικοδεσπότες",
    "pick_plan": "Επιλέξτε το πρόγραμμα που σας ταιριάζει"
  },
  "dash": {
    "welcome": "Καλώς ήρθατε,",
    "overview": "Επισκόπηση",
    "property": "Κατάλυμα",
    "rooms": "Δωμάτια",
    "bookings": "Κρατήσεις",
    "marketplace": "Δίκτυο",
    "groups": "Αιτήματα ομάδων",
    "reviews": "Αξιολογήσεις",
    "ical": "Συγχρονισμός OTA",
    "swaps": "Ανταλλαγές",
    "breakfast": "Πρωινό",
    "total_bookings": "Σύνολο κρατήσεων",
    "revenue": "Έσοδα",
    "open_offers": "Ανοιχτές προσφορές",
    "published": "Δημοσιευμένο",
    "not_published": "Μη δημοσιευμένο",
    "publish": "Δημοσίευση βιτρίνας",
    "unpublish": "Απόκρυψη βιτρίνας",
    "view_showcase": "Δείτε τη δημόσια βιτρίνα",
    "copy_link": "Αντιγραφή συνδέσμου",
    "copied": "Αντιγράφηκε!",
    "save": "Αποθήκευση αλλαγών",
    "saved": "Αποθηκεύτηκε",
    "name": "Όνομα",
    "city": "Πόλη",
    "region": "Περιφέρεια",
    "address": "Διεύθυνση",
    "country": "Χώρα",
    "country_help": "Πού βρίσκεται το ακίνητο: από εδώ προκύπτουν οι ταυτοποιητές και οι προθεσμίες που σας δείχνουμε.",
    "locality": "Δήμος / τοποθεσία",
    "currency": "Νόμισμα",
    "currency_help": "Το νόμισμα της χώρας. Οι τιμές των δωματίων και οι χρεώσεις παραμένουν σε ευρώ: ο ιστότοπος μετατρέπει μόνο για εμφάνιση.",
    "obligations_title": "Υποχρεώσεις της χώρας",
    "obligations_hint": "Τι πρέπει να δηλώνεται, σε ποιον και έως πότε. Η λίστα ακολουθεί τη χώρα του καταλύματος: αν αλλάξει η χώρα, αλλάζουν οι υποχρεώσεις.",
    "obligations_active": "Ενεργό",
    "obligations_toggle": "Σήμανση ως ενεργό",
    "obligations_source": "Επίσημη πηγή",
    "obligations_verified": "Επαληθεύτηκε στις",
    "obligations_error": "Δεν μπορώ να αποθηκεύσω την υποχρέωση",
    "timezone": "Ζώνη ώρας",
    "phone": "Τηλέφωνο",
    "desc_it": "Περιγραφή (IT)",
    "desc_en": "Περιγραφή (EN)",
    "amenities": "Παροχές (χωρισμένες με κόμμα)",
    "hero_image": "Κύρια φωτογραφία",
    "photos": "Συλλογή φωτογραφιών",
    "property_type": "Τύπος καταλύματος",
    "add_room": "Προσθήκη δωματίου",
    "room_name": "Όνομα δωματίου",
    "price_night": "Τιμή/νύχτα (€)",
    "capacity": "Χωρητικότητα",
    "photo_url": "URL φωτογραφίας",
    "publish_offer": "Δημοσίευση στο δίκτυο",
    "no_bookings": "Δεν υπάρχουν κρατήσεις ακόμη",
    "no_rooms": "Δεν υπάρχουν δωμάτια. Προσθέστε ένα για να ξεκινήσετε.",
    "offer_from": "Από",
    "offer_to": "Έως",
    "post_group_req": "Δημοσίευση αιτήματος ομάδας",
    "title": "Τίτλος",
    "guests": "Επισκέπτες",
    "budget": "Προϋπολογισμός/νύχτα (€)",
    "notes_it": "Σημειώσεις (IT)",
    "notes_en": "Σημειώσεις (EN)",
    "respond": "Απάντηση",
    "rooms_offered": "Δωμάτια που προσφέρονται",
    "message": "Μήνυμα",
    "send": "Αποστολή απάντησης",
    "responses": "απαντήσεις",
    "total": "Σύνολο",
    "night": "νύχτα",
    "nights": "νύχτες",
    "upload_photo": "Μεταφόρτωση φωτογραφίας",
    "uploading": "Μεταφόρτωση...",
    "drop_here": "Σύρετε ή κάντε κλικ για μεταφόρτωση",
    "remove": "Αφαίρεση",
    "ical_title": "Συγχρονίστε τις OTA μέσω iCal",
    "ical_sub": "Εισαγάγετε διαθεσιμότητα και κρατήσεις από Booking, Airbnb, Expedia, Vrbo.",
    "ical_url": "URL iCal",
    "ical_source": "Πλατφόρμα",
    "ical_import": "Εισαγωγή",
    "ical_last_sync": "Τελευταίος συγχρονισμός",
    "ical_events": "Συμβάντα που εισήχθησαν",
    "calendar_unified": "Ενιαίο ημερολόγιο",
    "swap_forward": "Προώθηση σε συνεργάτη",
    "swap_title": "Ανταλλαγή δωματίου",
    "partner_property": "Κατάλυμα συνεργάτη",
    "partner_room": "Δωμάτιο συνεργάτη",
    "commission_10": "Θα παρακρατηθεί προμήθεια 10%",
    "swap_notes": "Σημειώσεις για τον συνεργάτη",
    "swap_send": "Πρόταση ανταλλαγής",
    "no_swaps": "Δεν υπάρχουν ανταλλαγές ακόμη",
    "breakfast_title": "Κεντρικό πρωινό",
    "breakfast_sub": "Προσφέρετε ή κλείστε πρωινά για τους επισκέπτες του δικτύου.",
    "add_breakfast_slot": "Νέα βάρδια πρωινού",
    "slot_date": "Ημερομηνία",
    "slot_time": "Ώρα",
    "slot_max": "Μέγιστες θέσεις",
    "slot_price": "Τιμή/θέση (€)",
    "book_covers": "Κράτηση θέσεων",
    "covers": "θέσεις",
    "book_slot": "Κράτηση",
    "available": "διαθέσιμες",
    "your_breakfast_bookings": "Οι κρατήσεις πρωινού σας",
    "role": "Ρόλος",
    "date": "Ημερομηνία",
    "amount": "Ποσό",
    "source": "Προέλευση",
    "event_title": "Τίτλος",
    "start": "Έναρξη",
    "end": "Λήξη",
    "no_events": "Κανένα συμβάν — εισαγάγετε ένα iCal ή λάβετε κράτηση.",
    "welcome_back": "Καλώς ορίσατε ξανά",
    "toast_uploaded": "Μεταφορτώθηκε",
    "toast_upload_failed": "Η μεταφόρτωση απέτυχε",
    "toast_error": "Σφάλμα",
    "toast_swap_sent": "Ανταλλαγή προτάθηκε · ο επισκέπτης ειδοποιήθηκε",
    "toast_slot_added": "Βάρδια προστέθηκε",
    "toast_slot_booked": "Κρατήθηκε",
    "toast_offer_posted": "Προσφορά δημοσιεύτηκε",
    "toast_gr_posted": "Αίτημα δημοσιεύτηκε",
    "toast_response_sent": "Απάντηση στάλθηκε",
    "toast_imported": "Εισήχθησαν {n} συμβάντα",
    "select_room": "Επιλέξτε δωμάτιο",
    "select_partner": "Επιλέξτε συνεργάτη",
    "select_booking": "Επιλέξτε κράτηση",
    "no_paid_bookings": "Καμία πληρωμένη κράτηση",
    "per_cover": "ανά θέση",
    "outgoing": "εξερχόμενο",
    "incoming": "εισερχόμενο",
    "from_label": "Από:",
    "to_label": "Έως:",
    "commission_10pct": "Προμήθεια (10%)",
    "analytics": "Αναλυτικά",
    "revenue_monthly": "Μηνιαία έσοδα",
    "direct_bookings": "Άμεσες κρατήσεις",
    "swap_commissions": "Προμήθειες ανταλλαγών",
    "breakfast_income": "Έσοδα πρωινού",
    "no_analytics": "Δεν υπάρχουν δεδομένα — ξεκινήστε να λαμβάνετε κρατήσεις.",
    "stripe_connect": "Αυτόματες πληρωμές",
    "connect_start": "Ενεργοποίηση Stripe Connect",
    "connect_continue": "Ολοκλήρωση εγγραφής",
    "connect_done": "Πληρωμές ενεργές",
    "connect_pending": "Εγγραφή σε εξέλιξη",
    "connect_hint": "Λαμβάνετε αυτόματα τις άμεσες κρατήσεις καθαρές από την προμήθεια Hostaly (8% Base · 6% Pro · 4,5% Enterprise). Τα έξοδα Stripe για την επεξεργασία πληρωμών βαρύνουν τον συνδεδεμένο λογαριασμό.",
    "accept_split": "Αποδοχή και κατανομή",
    "select_partners": "Επιλέξτε συνεργάτες",
    "allocated_rooms": "Δωμάτια που κατανεμήθηκαν",
    "allocation_confirmed": "Κατανομή επιβεβαιώθηκε",
    "push_title": "Ειδοποιήσεις προγράμματος περιήγησης",
    "push_hint": "Λάβετε ειδοποίηση στη συσκευή ακόμη και με κλειστή καρτέλα.",
    "push_enable": "Ενεργοποίηση ειδοποιήσεων",
    "push_disable": "Απενεργοποίηση",
    "push_on": "Ενεργές",
    "push_off": "Ανενεργές",
    "push_denied": "Αποκλείστηκαν από το πρόγραμμα περιήγησης",
    "instagram": "Instagram",
    "ig_handle": "Λογαριασμός Instagram (@)",
    "ig_posts": "Πρόσφατες αναρτήσεις",
    "ig_add": "Προσθήκη ανάρτησης",
    "ig_image": "URL εικόνας",
    "ig_caption": "Λεζάντα",
    "ig_link": "Σύνδεσμος ανάρτησης",
    "verification": "Επαλήθευση",
    "verify_title": "Επαλήθευση καταλύματος",
    "verify_hint": "Τα επαληθευμένα καταλύματα εμφανίζουν το σήμα ✓ στην αγορά και στη βιτρίνα.",
    "verified": "Επαληθευμένο",
    "pending_verify": "Σε εκκρεμότητα",
    "not_verified": "Μη επαληθευμένο",
    "submit_verify": "Αίτημα επαλήθευσης",
    "vat_number": "ΑΦΜ",
    "business_name": "Επωνυμία",
    "municipality": "Δήμος",
    "declaration": "Δηλώνω υπεύθυνα ότι αυτά τα στοιχεία είναι σωστά",
    "admin": "Διαχείριση",
    "admin_pending": "Εκκρεμή αιτήματα",
    "approve": "Έγκριση",
    "reject": "Απόρριψη",
    "admin_note": "Εσωτερική σημείωση",
    "ai_copy": "Δημιουργία με AI",
    "ai_copy_title": "Δημιουργία βιτρίνας με AI",
    "ai_copy_hint": "Γράψτε λίγες λέξεις-κλειδιά — η AI θα φτιάξει την περιγραφή IT/EN και τις παροχές.",
    "ai_keywords": "Λέξεις-κλειδιά (χωρισμένες με κόμμα)",
    "ai_tone": "Τόνος",
    "ai_generate": "Δημιουργία",
    "ai_apply": "Εφαρμογή στη βιτρίνα",
    "promo_code": "Κωδικός έκπτωσης",
    "promo_apply": "Εφαρμογή",
    "promo_valid": "Έγκυρος κωδικός",
    "promo_saved": "Κερδίζετε",
    "trade_nav": "Trade B2B",
    "trade_title": "Χονδρική πώληση σε τουρ οπερέιτορ και πρακτορεία",
    "trade_sub": "Αγοράστε πακέτα δωματίων απευθείας από ιταλικά καταλύματα σε ειδικές τιμές.",
    "trade_offers": "Προσφορές trade",
    "trade_login": "Σύνδεση trade",
    "trade_register": "Καταχώριση πρακτορείου",
    "trade_company": "Όνομα πρακτορείου / τουρ οπερέιτορ",
    "trade_vat": "ΑΦΜ",
    "trade_country": "Χώρα",
    "trade_publish": "Δημοσίευση προσφοράς trade",
    "trade_new_offer": "Νέα προσφορά trade",
    "trade_rooms_available": "Διαθέσιμα δωμάτια",
    "trade_price_per_night": "Τιμή/δωμάτιο/νύχτα (€)",
    "trade_min_nights": "Ελάχιστες νύχτες",
    "trade_buy": "Αγορά τώρα",
    "trade_orders_mine": "Οι κρατήσεις μου",
    "trade_sold": "πουλήθηκαν",
    "trade_tab": "Trade",
    "partner_center_tab": "Partner Center",
    "channels_tab": "Κανάλια OTA",
    "b2b_title": "Κανάλι B2B · bedbank",
    "b2b_subtitle": "Αγοράστε καθαρές τιμές από bedbank, εφαρμόστε το περιθώριό σας και επιστρέψτε την προμήθεια στον συνεργάτη.",
    "b2b_suppliers": "Προμηθευτές",
    "b2b_add_supplier": "Προσθήκη προμηθευτή",
    "b2b_mapping": "Αντιστοίχιση ξενοδοχείων",
    "b2b_rules": "Κανόνες τιμών",
    "b2b_simulator": "Προσομοιωτής",
    "b2b_settlements": "Εκκαθαρίσεις",
    "b2b_net": "Καθαρή τιμή",
    "b2b_nights": "Νύχτες",
    "b2b_markup": "Προσαύξηση",
    "b2b_rebate": "Επιστροφή",
    "b2b_msp": "Ελάχιστη τιμή (MSP)",
    "b2b_gross": "Τιμή στο κοινό",
    "b2b_charged": "Εισπράχθηκε τώρα",
    "b2b_margin": "Περιθώριο",
    "b2b_blocked": "Μη πωλήσιμο",
    "b2b_msp_binding": "Τιμή δεσμευμένη από το ελάχιστο του προμηθευτή",
    "b2b_cashback": "Η επιστροφή έρχεται μετά την κράτηση",
    "b2b_needed_markup": "Απαιτούμενη προσαύξηση",
    "b2b_target_margin": "Στόχος περιθωρίου",
    "b2b_credentials_missing": "Λείπουν διαπιστευτήρια",
    "b2b_confirmed_by": "Επιβεβαιώθηκε από",
    "b2b_auto": "Συνδέθηκε αυτόματα",
    "b2b_review": "Προς επιβεβαίωση",
    "b2b_no_candidates": "Κανένας συμβατός υποψήφιος",
    "b2b_partners": "Αντισυμβαλλόμενοι",
    "b2b_add_partner": "Προσθήκη αντισυμβαλλομένου",
    "b2b_partner_kind": "Τύπος",
    "b2b_partner_agency": "Πρακτορείο",
    "b2b_partner_tour_operator": "Τουρ οπερέιτορ",
    "b2b_partner_hotel": "Άλλο ξενοδοχείο",
    "b2b_partner_vat": "ΑΦΜ",
    "b2b_payment_terms": "Όροι πληρωμής",
    "b2b_credit_risk": "Κίνδυνος αθέτησης",
    "b2b_credit_limit": "Πιστωτικό όριο",
    "b2b_terms_agency": "Πρακτορεία και άλλα ξενοδοχεία: χωρίς είσπραξη από καταναλωτές, άρα χωρίς πληρωμή με κάρτα.",
    "b2b_outstanding": "Προς εξόφληση",
    "b2b_rates": "Τιμοκατάλογος ανά αντισυμβαλλόμενο",
    "b2b_net_rate": "Καθαρή τιμή",
    "b2b_public_price": "Τιμή βιτρίνας",
    "b2b_above_public": "Πάνω από την τιμή βιτρίνας",
    "b2b_above_public_hint": "Ζητάτε από τον αντισυμβαλλόμενο περισσότερα από όσα ζητάτε από έναν επισκέπτη της βιτρίνας. Το πρακτορείο το αντιλαμβάνεται και σας παρακάμπτει."
  },
  "vetrina": {
    "book": "Κράτηση",
    "from": "από",
    "per_night": "/ νύχτα",
    "rooms": "Δωμάτια",
    "reviews": "Αξιολογήσεις",
    "contact": "Επικοινωνία",
    "leave_review": "Αφήστε αξιολόγηση",
    "guest_name": "Το όνομά σας",
    "rating": "Αξιολόγηση",
    "comment": "Το σχόλιό σας",
    "submit": "Αποστολή αξιολόγησης",
    "services": "Παροχές",
    "check_in": "Άφιξη",
    "check_out": "Αναχώρηση",
    "guest_email": "Το email σας",
    "confirm_book": "Επιβεβαίωση και πληρωμή",
    "total_price": "Σύνολο",
    "processing": "Επεξεργασία...",
    "book_this_room": "Κράτηση αυτού του δωματίου",
    "promo_code": "Κωδικός έκπτωσης",
    "promo_apply": "Εφαρμογή",
    "promo_valid": "Έγκυρος κωδικός",
    "promo_saved": "Κερδίζετε",
    "traveller_nudge": "Είστε ταξιδιώτης;",
    "prefill_login": "Συνδεθείτε για να συμπληρωθούν τα στοιχεία σας →",
    "beds": "Κρεβάτια",
    "beds_hint": "Τιμή ανά κρεβάτι: {count} κρεβάτια διαθέσιμα σε αυτόν τον κοιτώνα.",
    "phone": "Τηλέφωνο",
    "phone_optional": "Τηλέφωνο (προαιρετικό)",
    "phone_placeholder": "+30 690 123 4567",
    "phone_hint": "Ο οικοδεσπότης θα το χρησιμοποιήσει μόνο για επικοινωνία σχετικά με αυτή την κράτηση.",
    "charged_in": "Χρέωση σε {currency} · {amount}",
    "fx_note": "Ισοτιμία ΕΚΤ: 1 EUR = {rate} {currency} ({date})",
    "fx_stale": "τελευταία διαθέσιμη ισοτιμία",
    "pay_now": "Πληρωμή τώρα",
    "pay_now_hint": "Κάρτα · άμεση χρέωση",
    "pay_at_property": "Πληρωμή στο κατάλυμα",
    "pay_at_property_hint": "Κάρτα ως εγγύηση · χρέωση μόνο σε no-show",
    "pay_at_hotel": "Πληρωμή στο ξενοδοχείο",
    "pay_at_hotel_hint": "Πληρώνετε τα πάντα στο check-in · απαιτείται κάρτα ως εγγύηση",
    "pay_at_hotel_title": "Πληρώνετε τα πάντα στο check-in, στο κατάλυμα",
    "pay_at_hotel_step1": "Δεν χρεώνεται τίποτα τώρα: εξοφλείτε ολόκληρη τη διαμονή στο check-in, απευθείας στο κατάλυμα.",
    "pay_at_hotel_step2": "Απαιτείται έγκυρη πιστωτική κάρτα για την εγγύηση της κράτησης. Δεν χρεώνεται σήμερα: τη φυλάμε μόνο ως εγγύηση.",
    "pay_at_hotel_step3": "Η κάρτα χρεώνεται μόνο σε περίπτωση no-show ή ακύρωσης εκτός προθεσμίας, σύμφωνα με την πολιτική του καταλύματος.",
    "pay_at_hotel_total": "Σύνολο προς πληρωμή στο κατάλυμα",
    "pay_at_hotel_continue": "Συνέχεια με την κάρτα εγγύησης",
    "pay_at_hotel_unavailable": "Η εγγύηση με κάρτα δεν είναι διαθέσιμη αυτή τη στιγμή: κάντε κράτηση με πληρωμή κάρτας ή επικοινωνήστε με το κατάλυμα.",
    "paypal_hint": "Πληρωμή με τον λογαριασμό σας PayPal",
    "pay_with_paypal": "Πληρωμή με PayPal",
    "paypal_note": "Θα μεταφερθείτε στο PayPal για να ολοκληρώσετε με ασφάλεια την πληρωμή και μετά επιστρέφετε εδώ.",
    "redirecting": "Ανακατεύθυνση…",
    "enter_email_code": "Εισαγάγετε email και κωδικό",
    "invalid_code": "Μη έγκυρος κωδικός",
    "phone_invalid": "Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνου",
    "name_email_required": "Απαιτούνται όνομα και email",
    "pick_dates": "Επιλέξτε ημερομηνίες",
    "accept_policy": "Πρέπει να αποδεχτείτε την πολιτική no-show για να συνεχίσετε",
    "report_content": "Αναφορά περιεχομένου",
    "guest_terms": "Όροι κράτησης",
    "free_cancel": "Δωρεάν ακύρωση",
    "no_show_policy": "Πολιτική no-show",
    "penalty": "Ποινή",
    "free_cancel_note": "Δωρεάν ακύρωση έως {days} ημέρες πριν το check-in.",
    "free_cancel_note_one": "Δωρεάν ακύρωση έως 1 ημέρα πριν το check-in.",
    "by_date": "Έως {date}.",
    "then_retained": "Μετά, παρακρατείται το {percent}%.",
    "penalty_note": "Ακύρωση με ποινή: {penalty}.",
    "first_night": "πρώτη νύχτα",
    "percent_of_total": "{percent}% του συνόλου",
    "guarantee_card": "Κάρτα ως εγγύηση",
    "no_charge_note": "Δεν γίνεται χρέωση τώρα. Κάνουμε μόνο μια προσωρινή επαλήθευση 1 € (που απελευθερώνεται αμέσως) για να ελέγξουμε την κάρτα.",
    "no_show_consent": "Αποδέχομαι ότι σε περίπτωση no-show μετά την προθεσμία θα χρεωθεί το ποσό των {amount} στην παραπάνω κάρτα.",
    "confirm_no_charge": "Επιβεβαίωση κράτησης (χωρίς χρέωση)",
    "please_wait": "Παρακαλώ περιμένετε…",
    "booking_confirmed": "Η κράτηση επιβεβαιώθηκε · Κάρτα •••• {last4} καταχωρήθηκε ως εγγύηση",
    "verified": "Επαληθευμένο",
    "guest_favourite": "Αγαπημένο των επισκεπτών",
    "guest_favourite_hint": "Αγαπημένο των επισκεπτών — για τα καταλύματα με τις καλύτερες αξιολογήσεις",
    "rates_loading": "Φόρτωση ισοτιμιών...",
    "per_bed_night": "ανά κρεβάτι / νύχτα",
    "dorm_badge": "Δωμάτιο {gender} · {beds} κρεβάτια",
    "floor": "Όροφος {number}",
    "free_cancel_badge": "Δωρεάν ακύρωση έως {days} ημέρες πριν",
    "guest": "Επισκέπτης",
    "thanks": "Ευχαριστούμε!",
    "posting_as": "Δημοσιεύετε ως",
    "rating_5": "Τέλειο",
    "rating_4": "Καλό",
    "rating_3": "Μέτριο",
    "rating_2": "Ανεπαρκές",
    "rating_1": "Πολύ κακό",
    "dictate_review": "Υπαγορεύστε την αξιολόγηση",
    "gender_mixed": "μικτό",
    "gender_female": "γυναικείο",
    "gender_male": "ανδρικό"
  },
  "guest": {
    "my_bookings": "Οι κρατήσεις μου",
    "my_maps": "Οι χάρτες μου",
    "travellers_area": "Περιοχή ταξιδιωτών",
    "have_account": "Έχετε ήδη λογαριασμό;",
    "login": "Σύνδεση",
    "signup": "Εγγραφή"
  },
  "pay": {
    "success": "Η κράτηση επιβεβαιώθηκε",
    "success_body": "Θα λάβετε email επιβεβαίωσης. Ευχαριστούμε!",
    "cancel": "Η πληρωμή ακυρώθηκε",
    "cancel_body": "Δεν έγινε καμία χρέωση.",
    "back_home": "Επιστροφή στην αρχική",
    "checking": "Έλεγχος πληρωμής..."
  },
  "common": {
    "close": "Κλείσιμο",
    "cancel": "Ακύρωση",
    "loading": "Φόρτωση...",
    "city": "Πόλη",
    "filter_city": "Φίλτρο ανά πόλη"
  },
  "trip_group": {
    "propose_title": "Άλλοι επισκέπτες στις ημερομηνίες σας",
    "propose_caption": "Υπάρχει ομάδα ταξιδιωτών για {from} → {until}. Μπορείτε να συμμετάσχετε, έστω και μόνο για συζήτηση: καμία υποχρέωση να ταξιδέψετε μαζί.",
    "joined_title": "Είστε στην ομάδα",
    "joined_caption": "Η συζήτηση της ομάδας είναι ανοιχτή κατά τις κοινές ημερομηνίες.",
    "join": "Συμμετοχή",
    "more": "Πώς λειτουργεί",
    "consent_note": "Με τη συμμετοχή ενεργοποιείτε τη συγκατάθεση για ομάδες ταξιδιωτών. Είναι γενική και ανακλητή: καμία υποχρέωση να ταξιδέψετε μαζί.",
    "consent_enable": "Ενεργοποίηση συμμετοχής",
    "optin_badge": "Μεμονωμένοι ταξιδιώτες",
    "optin_title": "Ταξιδεύετε μόνοι; Κάποιοι ζουν τις ίδιες εμπειρίες.",
    "optin_caption": "Στις ημερομηνίες σας κάποιοι επισκέπτονται, τρώνε και περπατούν εκεί που πάτε: ενωθείτε με την ομάδα και μοιραστείτε μόνο ό,τι θέλετε.",
    "optin_body": "Η συμμετοχή επιβεβαιώνεται μόνο τη στιγμή του ταξιδιού και αποσύρεται όποτε θέλετε, χωρίς συνέπειες στην κράτηση.",
    "optin_on": "Ενεργή συμμετοχή",
    "optin_off": "Δεν συμμετέχω",
    "optin_saved": "Η προτίμηση αποθηκεύτηκε. Μπορείτε να την αλλάξετε όποτε θέλετε.",
    "optin_login": "Συνδεθείτε ως ταξιδιώτης για να την ενεργοποιήσετε",
    "optin_error": "Δεν μπορώ να αποθηκεύσω την προτίμηση.",
    "login_required": "Συνδεθείτε για να συμμετάσχετε στην ομάδα.",
    "join_failed": "Δεν μπορώ να σας προσθέσω στην ομάδα.",
    "cap_reached": "Είστε ήδη σε 2 ομάδες που επικαλύπτονται: βγείτε από μία για να μπείτε σε αυτή.",
    "tooltip_title": "Ομάδες ταξιδιωτών",
    "tooltip_1": "Η ομαδοποίηση γίνεται ανά τόπο και περίοδο: αρκεί μία κοινή ημέρα διαμονής.",
    "tooltip_2": "Μπορείτε να είστε σε πολλές ομάδες, αλλά το πολύ δύο επικαλύπτονται στις ίδιες ημερομηνίες.",
    "tooltip_3": "Η συζήτηση είναι ανοιχτή μόνο κατά τις κοινές ημερομηνίες: μηνύματα εκτός αυτών δεν φτάνουν.",
    "tooltip_4": "Τα άλλα μέλη βλέπουν μόνο ένα σύντομο όνομα, ποτέ τις λεπτομέρειες της κράτησής σας.",
    "tooltip_5": "Αν ακυρώσετε την κράτηση βγαίνετε από την ομάδα· αν μείνετε μόνος, η ομάδα κλείνει.",
    "tooltip_window": "Περίοδος",
    "loading": "Φόρτωση...",
    "back": "Πίσω",
    "chat_title": "Συζήτηση ομάδας",
    "chat_hint": "Μόνο τα μέλη με κοινές ημερομηνίες βλέπουν αυτά τα μηνύματα. Δεν κοινοποιούνται λεπτομέρειες κράτησης.",
    "chat_failed": "Δεν μπορώ να φορτώσω τη συζήτηση.",
    "send_failed": "Το μήνυμα δεν στάλθηκε.",
    "chat_empty": "Γράψτε ένα μήνυμα.",
    "no_access": "Χωρίς πρόσβαση",
    "no_access_detail": "Η συζήτηση είναι για μέλη με κοινή διαμονή και ανοιχτή μόνο κατά τις κοινές ημερομηνίες.",
    "no_access_after_consent": "Η συγκατάθεση είναι ενεργή, αλλά δεν ανήκετε σε αυτή την ομάδα: οι ημερομηνίες δεν συμπίπτουν πια ή η ομάδα έκλεισε.",
    "not_found": "Η ομάδα δεν βρέθηκε",
    "no_messages": "Δεν υπάρχουν μηνύματα ακόμη. Σπάστε τον πάγο.",
    "new_message": "Νέο μήνυμα",
    "message_placeholder": "Γράψτε κάτι στην ομάδα...",
    "send": "Αποστολή",
    "cancel": "Ακύρωση",
    "announce": "Ανακοίνωση",
    "announcement": "Ανακοίνωση",
    "meeting": "Συνάντηση",
    "meeting_proposal": "Πρόταση συνάντησης",
    "new_meeting": "Προτείνετε συνάντηση",
    "meeting_when": "Πότε",
    "meeting_when_placeholder": "π.χ. Σάββατο πρωί",
    "meeting_when_required": "Πείτε πότε.",
    "meeting_where": "Πού",
    "meeting_where_placeholder": "π.χ. η είσοδος του μουσείου",
    "meeting_where_required": "Πείτε πού.",
    "meeting_note": "Σημείωση (προαιρετική)",
    "meeting_note_placeholder": "Κάτι να προσθέσετε;",
    "propose": "Πρόταση",
    "members": "Μέλη",
    "member_count": "Μέλη: {n}",
    "no_members": "Δεν υπάρχουν μέλη ακόμη.",
    "anonymous": "Επισκέπτης",
    "chat_ok": "Στη συζήτηση",
    "chat_no": "Μόνο ομάδα"
  }
};
